import { atom } from 'recoil'

const hasUpdatedDocumentStatusAtom = atom<boolean>({
  key: 'hasUpdatedDocumentStatusAtom',
  default: false,
})

export default hasUpdatedDocumentStatusAtom
